export default __webpack_public_path__ + "static/media/icon5_blue.dfff3b47.svg";